import { render, staticRenderFns } from "./abandonDeviceDataShow.vue?vue&type=template&id=28496fe8&scoped=true&"
import script from "./abandonDeviceDataShow.vue?vue&type=script&lang=js&"
export * from "./abandonDeviceDataShow.vue?vue&type=script&lang=js&"
import style0 from "./abandonDeviceDataShow.vue?vue&type=style&index=0&id=28496fe8&prod&lang=scss&"
import style1 from "./abandonDeviceDataShow.vue?vue&type=style&index=1&id=28496fe8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28496fe8",
  null
  
)

export default component.exports